// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_f9-3";
export var flatBottomCorners = "_f9-5";
export var productImage = "_f9-0";
export var quantityContainer = "_f9-2";
export var quantityHeader = "_f9-6";
export var tooltip = "_f9-1";
export var wrapAndEllipsesOverflow = "_f9-4";